module.exports = __webpack_public_path__ + "static/media/rounded_warning.30f19e9e.svg";